import { GetterTree } from "vuex";
import { MypageState, RootState } from "@/types/mypage";
import NativeClient from "@/client/native-client";

const getters: GetterTree<MypageState, RootState> = {
  getAddRecipeResult: (state: MypageState) => {
    return state.addRecipeResult;
  },
  getDeleteRecipeResult: (state: MypageState) => {
    return state.deleteRecipeResult;
  },
  getRecentFavoriteRecipeList: (state: MypageState) => {
    NativeClient.sendDebugLog("Getters.ts getRecentFavoriteRecipeList totalCount = " + state.recentFavoriteRecipeList?.totalCount);
    NativeClient.sendDebugLog("Getters.ts getRecentFavoriteRecipeList recipeList.count = " + state.recentFavoriteRecipeList?.clips.length);
    return state.recentFavoriteRecipeList;
  },
  getFavoriteRecipeList: (state: MypageState) => {
    NativeClient.sendDebugLog("Getters.ts getFavoriteRecipeList totalCount = " + state.favoriteRecipeList?.totalCount);
    NativeClient.sendDebugLog("Getters.ts getFavoriteRecipeList recipeList.count = " + state.favoriteRecipeList?.clips.length);
    return state.favoriteRecipeList;
  },
  getFolderRecipeList: (state: MypageState) => {
    NativeClient.sendDebugLog("Getters.ts getFolderRecipeList totalCount = " + state.folderRecipeList?.totalCount);
    NativeClient.sendDebugLog("Getters.ts getFolderRecipeList recipeList.count = " + state.folderRecipeList?.clips.length);
    return state.folderRecipeList;
  },
  getFolderList: (state: MypageState) => {
    return state.folderList;
  },
  getRegistFolderResult: (state: MypageState) => {
    return state.registFolderResult;
  },
  getRenameFolderResult: (state: MypageState) => {
    return state.renameFolderResult;
  },
  getDeleteFolderResult: (state: MypageState) => {
    return state.deleteFolderResult;
  },
  getAddFolderRecipeResult: (state: MypageState) => {
    return state.addFolderRecipeResult;
  },
  getDeleteFolderRecipeResult: (state: MypageState) => {
    return state.deleteFolderRecipeResult;
  },
  getFolderMoveResult: (state: MypageState) => {
    return state.folderMoveResult;
  },
  getFolderName: (state: MypageState) => {
    return state.folderName;
  },
  getSelectedTab: (state: MypageState) => {
    return state.selectedTab;
  },
  getFavoriteFoodList: (state: MypageState) => {
    return state.favoriteFoodList;
  },
  getInquiryStatus: (state: MypageState) => {
    return state.inquiryStatus;
  },
  getFoodsRanking: (state: MypageState) => {
    return state.foodsRanking;
  },
  getUserRanking: (state: MypageState) => {
    return state.userRanking;
  },
  getMonthlyUserRanking: (state: MypageState) => (yearMonth: string) => {
    if (state.monthlyUsedRanking != null) {
      const findElement = state.monthlyUsedRanking.find(element => element.month == yearMonth);
      if (findElement != undefined) {
        return findElement;
      }
    }
    return null;
  },
  getPersonalMonthlyUsedFoodsRanking: (state: MypageState) => (yearMonth: string) => {
    if (state.personalMonthlyUsedFoodsRanking != null) {
      const findElement = state.personalMonthlyUsedFoodsRanking.find(element => element.month == yearMonth);
      if (findElement != undefined) {
        return findElement;
      }
    }
    return null;
  },
  getPersonalMonthlyDisposedFoodsRanking: (state: MypageState) => (yearMonth: string) => {
    if (state.personalMonthlyDisposedFoodsRanking != null) {
      const findElement = state.personalMonthlyDisposedFoodsRanking.find(element => element.month == yearMonth);
      if (findElement != undefined) {
        return findElement;
      }
    }
    return null;
  },
  getNationwideMonthlyUsedFoodsRanking: (state: MypageState) => (yearMonth: string) => {
    if (state.nationwideMonthlyUsedFoodsRanking != null) {
      const findElement = state.nationwideMonthlyUsedFoodsRanking.find(element => element.month == yearMonth);
      if (findElement != undefined) {
        return findElement;
      }
    }
    return null;
  },
  getNationwideMonthlyDisposedFoodsRanking: (state: MypageState) => (yearMonth: string) => {
    if (state.nationwideMonthlyDisposedFoodsRanking != null) {
      const findElement = state.nationwideMonthlyDisposedFoodsRanking.find(element => element.month == yearMonth);
      if (findElement != undefined) {
        return findElement;
      }
    }
    return null;
  },
  getTopHistoryRecipe: (state: MypageState) => {
    return state.topHistoryRecipe;
  },
  getHistoryRecipe: (state: MypageState) => {
    return state.historyRecipe;
  },
  getSelectedMonthIndex: (state: MypageState) => {
    return state.selectedMonthIndex;
  }
};

export default getters;
